import React from "react";
import Col from "react-bootstrap/Col";
import Plus from "../../../../../images/icons/circle-plus.svg";
import TopArrow from "../../../../../images/icons/top-small-arrow.svg";
import DownArrow from "../../../../../images/icons/bottom-small-arrow.svg";
import userTypeConsts from "../../../../../constants/userTypeConsts.js";
import { StatusDropdown } from "../trackerComponents";

const ProjectSelector = ({
  projectDropdownRef,
  projectDropdownOpen,
  setProjectDropdownOpen,
  projectStatusFilter,
  setProjectStatusFilter,
  isProjectStatusDropdownOpen,
  setIsProjectStatusDropdownOpen,
  projectStatusDropdownRef,
  filter,
  setFilter,
  selectedClients,
  setSelectedClients,
  selectedProject,
  setSelectedProject,
  filteredClientData,
  user,
  letterCount,
  trackerOuterRef2,
  projectName,
  sprintName,
  client,
  setProjectName,
  setProjectId,
  setClient,
  setClientId,
  setIsBillable,
  setSprintId,
  setSprintName,
  setTaskError,
  setTagDropdownOpen,
}) => {
  const handleProjectClick = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
    setProjectStatusFilter("Active");
    setFilter("");
    setSelectedClients(new Set());
    setSelectedProject(null);
    setTaskError(false);
    setTagDropdownOpen(false);
  };

  const handleProjectStatusChange = (status) => {
    setProjectStatusFilter(status);
    setSelectedClients(new Set());
  };

  const handleFilterChange = (e) => {
    const filterValue = e.target.value;
    setFilter(filterValue);
    if (filterValue === "") {
      setSelectedClients(new Set());
    } else {
      const matchingClients = filteredClientData.filter((clientItem) =>
        clientItem.projects.some(
          (project) =>
            project.project_name
              .toLowerCase()
              .includes(filterValue.toLowerCase()) &&
            (projectStatusFilter === "All"
              ? true
              : projectStatusFilter === "Active"
                ? project.is_active === true
                : project.is_active === false && project.is_archived === false)
        )
      );
      setSelectedClients(new Set(matchingClients));
    }
  };

  const handleClientToggle = (clientItem) => {
    if (
      clientItem.projects.filter(
        (project) =>
          project.project_name.toLowerCase().includes(filter.toLowerCase()) &&
          (projectStatusFilter === "All"
            ? true
            : projectStatusFilter === "Active"
              ? project.is_active === true
              : project.is_active === false)
      ).length > 0
    ) {
      const newSelectedClients = new Set(selectedClients);
      if (selectedClients.has(clientItem)) {
        newSelectedClients.delete(clientItem);
      } else {
        newSelectedClients.add(clientItem);
      }
      setSelectedClients(newSelectedClients);
    }
  };

  const handleSprintSelect = (project, sprint, clientItem) => {
    setProjectName(project.project_name);
    setProjectId(project._id);
    setClient(clientItem?.client_name && clientItem.client_name);
    setClientId(clientItem._id && clientItem._id);
    setIsBillable(project.is_billable);
    setSprintId(sprint._id);
    setSprintName(sprint.sprint_name);
    setProjectDropdownOpen(false);
  };

  return (
    <div className="project-sprint" ref={projectDropdownRef}>
      <Col
        style={{ cursor: "pointer" }}
        onClick={handleProjectClick}
        className="project-sprint-outer"
      >
        {projectName && (
          <span className={`tooltip-tracker ${letterCount < 34 ? "small" : "large"}`}>
            {projectName} {sprintName ? ` - ${sprintName}` : ""}{" "}
            {projectName && (
              <div className="project-name-tracker">{client}</div>
            )}
          </span>
        )}
        <div
          className={`tracker-top-outer-project ${letterCount} ${letterCount < 34 ? "small" : "large"}`}
          ref={trackerOuterRef2}
          style={{
            display: "inline-block",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            height: "22px",
            maxWidth: "294.91px",
          }}
        >
          {!projectName && (
            <>
              <img src={Plus} alt="plus" />{" "}
            </>
          )}
          {projectName ? projectName : "Sprint/Project"}
          {sprintName ? ` - ${sprintName}` : ""}
          {projectName && (
            <div className="project-name-tracker">{client}</div>
          )}
        </div>
      </Col>

      {projectDropdownOpen && (
        <div className="custom-dropdown new-active-inactive">
          {(user.userType === userTypeConsts.SUPER_ADMIN ||
            user.userType === userTypeConsts.ADMIN) && (
            <StatusDropdown
              label="Filter by Status"
              statusFilter={projectStatusFilter}
              setStatusFilter={handleProjectStatusChange}
              isDropdownOpen={isProjectStatusDropdownOpen}
              setIsDropdownOpen={setIsProjectStatusDropdownOpen}
              dropdownRef={projectStatusDropdownRef}
            />
          )}
          <div className="top-search-tracker-for">
            <input
              type="text"
              className="search-bar"
              placeholder="Find Project or Client"
              value={filter}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>
          <ul
            className={`tracker-who-list client-list client-list-filter ${
              user.userType !== userTypeConsts.SUPER_ADMIN &&
              user.userType !== userTypeConsts.ADMIN
                ? "filter-active-no"
                : ""
            }`}
          >
            {filteredClientData.map((clientItem) => (
              <div key={clientItem._id} className="main-outer-item-dd">
                <div
                  className={`client-name1 cursor ${
                    selectedClients.has(clientItem) ? "selected" : ""
                  }`}
                  onClick={() => handleClientToggle(clientItem)}
                >
                  <span className="main-project">{clientItem.client_name} </span>
                  {clientItem.projects.filter(
                    (project) =>
                      project.project_name
                        .toLowerCase()
                        .includes(filter.toLowerCase()) &&
                      (projectStatusFilter === "All"
                        ? true
                        : projectStatusFilter === "Active"
                          ? project.is_active === true
                          : project.is_active === false)
                  ).length > 0 && (
                    <span
                      className={`arrow ${
                        selectedClients.has(clientItem) ? "open" : ""
                      }`}
                    >
                      <span className="main-project-title">
                        {
                          clientItem.projects.filter(
                            (project) =>
                              project.project_name
                                .toLowerCase()
                                .includes(filter.toLowerCase()) &&
                              (projectStatusFilter === "All"
                                ? true
                                : projectStatusFilter === "Active"
                                  ? project.is_active === true
                                  : project.is_active === false)
                          ).length
                        }{" "}
                        Projects
                      </span>
                      {selectedClients.has(clientItem) ? (
                        <img src={TopArrow} alt="Open" />
                      ) : (
                        <img src={DownArrow} alt="Close" />
                      )}
                    </span>
                  )}
                </div>
                {selectedClients.has(clientItem) && (
                  <div className="project-name1-outer">
                    {clientItem.projects.filter(
                      (project) =>
                        project.project_name
                          .toLowerCase()
                          .includes(filter.toLowerCase()) &&
                        (projectStatusFilter === "All"
                          ? true
                          : projectStatusFilter === "Active"
                            ? project.is_active === true
                            : project.is_active === false)
                    ).length === 0 ? (
                      <div>No projects under this client</div>
                    ) : (
                      clientItem.projects
                        .filter(
                          (project) =>
                            project.project_name
                              .toLowerCase()
                              .includes(filter.toLowerCase()) &&
                            (projectStatusFilter === "All"
                              ? true
                              : projectStatusFilter === "Active"
                                ? project.is_active === true
                                : project.is_active === false) &&
                            project.is_archive !== true
                        )
                        .sort((a, b) =>
                          a.project_name.localeCompare(b.project_name)
                        )
                        .map((project) => (
                          <div key={project._id}>
                            <div
                              className={`project-name1 ${
                                selectedProject === project ? "selected" : ""
                              }`}
                            >
                              <div
                                onClick={() =>
                                  setSelectedProject(
                                    selectedProject === project ? null : project
                                  )
                                }
                                className="project-dd-title"
                              >
                                {project.project_name}{" "}
                              </div>
                              <div className="cursor">
                                {project.sprints.length > 0 && (
                                  <span
                                    className={`arrow ${
                                      selectedProject === project ? "open" : ""
                                    }`}
                                    onClick={() =>
                                      setSelectedProject(
                                        selectedProject === project
                                          ? null
                                          : project
                                      )
                                    }
                                  >
                                    <span className="main-project-title">
                                      {project.sprints.length} Sprints
                                    </span>
                                    {selectedProject === project ? (
                                      <img src={TopArrow} alt="Open" />
                                    ) : (
                                      <img src={DownArrow} alt="Close" />
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                            {selectedProject === project && (
                              <div>
                                {project.sprints.length === 0 ? (
                                  <div> No sprints under this project </div>
                                ) : (
                                  <ul className="sprint-list">
                                    {project.sprints
                                      .sort((a, b) =>
                                        a.sprint_name.localeCompare(b.sprint_name)
                                      )
                                      .map((sprint) => (
                                        <li
                                          key={sprint._id}
                                          onClick={() =>
                                            handleSprintSelect(
                                              project,
                                              sprint,
                                              clientItem
                                            )
                                          }
                                        >
                                          {sprint.sprint_name}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>
                        ))
                    )}
                  </div>
                )}
              </div>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProjectSelector;
